import type { CSSProperties, ReactElement } from 'react';
import type { LayoutProps, SpaceProps } from 'styled-system';
import { space, layout } from 'styled-system';
import styled from 'styled-components';
import type { ButtonType } from '@ingka/button';
import Button from '@ingka/button';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/focus/dist/style.css';

export enum ButtonTypeEnum {
  primary = 'primary',
  emphasised = 'emphasised',
  secondary = 'secondary',
  tertiary = 'tertiary'
}

const Box = styled.div`
  ${layout}
  ${space}
`;

type ExtendProps = CSSProperties & SpaceProps & LayoutProps & React.HTMLAttributes<HTMLDivElement>;

export interface ButtonProps extends ExtendProps {
  children?: React.ReactNode | React.ReactNode[];
  className?: string;
  disabled?: boolean;
  expanding?: boolean;
  fluid?: boolean;
  href?: string;
  htmlType?: string;
  iconOnly?: boolean;
  iconPosition?: 'leading' | 'trailing';
  inverseTheme?: boolean;
  loading?: boolean;
  loadingSrText?: string | ReactElement;
  newWindow?: boolean;
  onClick?: (...args: any[]) => any;
  prefix?: string;
  ssrIcon?: (...args: any[]) => any;
  text?: string | ReactElement;
  type?: ButtonType | undefined;
  expandedOnTouchDevice?: boolean;
  dataTestId?: string;
  size?: 'xsmall' | 'small' | 'medium';
  buttonStyle?: CSSProperties | undefined;
  buttonId?: string;
  ariaExpanded?: boolean;
  ariaPressed?: boolean;
}

const SkapaButton = ({
  children,
  className,
  disabled,
  expanding,
  fluid,
  href,
  htmlType,
  iconOnly,
  iconPosition,
  inverseTheme,
  loading,
  loadingSrText,
  newWindow,
  onClick,
  prefix,
  size,
  ssrIcon,
  text,
  type,
  expandedOnTouchDevice,
  dataTestId,
  buttonStyle,
  buttonId,
  ariaExpanded,
  ariaPressed,
  ...props
}: ButtonProps) => {
  return (
    <Box {...props}>
      <Button
        children={children}
        className={className}
        disabled={disabled}
        expanding={expanding}
        fluid={fluid}
        href={href}
        htmlType={htmlType as 'button' | 'submit' | 'reset'}
        iconOnly={iconOnly}
        iconPosition={iconPosition}
        inverseTheme={inverseTheme}
        loading={loading}
        loadingSrText={loadingSrText}
        newWindow={newWindow}
        onClick={onClick}
        prefix={prefix}
        size={size}
        ssrIcon={ssrIcon}
        text={text}
        type={type}
        expandedOnTouchDevice={expandedOnTouchDevice}
        data-testid={dataTestId}
        style={{ ...buttonStyle, width: '100%' }}
        id={buttonId}
        aria-pressed={ariaPressed}
        aria-expanded={ariaExpanded}
      />
    </Box>
  );
};

export default SkapaButton;
